var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 72",
    style: {
      enableBackground: "new 0 0 66 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7CC279;}\n\t.st1{fill:#595959;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.65,54.37c-0.03,0.12-0.06,0.25-0.06,0.39v15.34c0,0.78,0.63,1.42,1.42,1.42h2.51 c0.78,0,1.42-0.63,1.42-1.42V55.47H3.37C3,55.47,2.76,55.02,2.65,54.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.84,70.09c0,0.78,0.63,1.42,1.42,1.42h2.51c0.78,0,1.42-0.63,1.42-1.42V55.47h-5.34V70.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.08,70.09c0,0.78,0.63,1.42,1.42,1.42h2.51c0.78,0,1.42-0.63,1.42-1.42V55.47h-5.34V70.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.33,70.09c0,0.78,0.63,1.42,1.42,1.42h2.51c0.78,0,1.42-0.63,1.42-1.42V55.47h-5.34V70.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.57,70.09c0,0.78,0.63,1.42,1.42,1.42h2.51c0.78,0,1.42-0.63,1.42-1.42V55.47h-5.34V70.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.82,70.09c0,0.78,0.63,1.42,1.42,1.42h2.51c0.78,0,1.42-0.63,1.42-1.42V55.47h-5.34V70.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.35,54.37c-0.11,0.65-0.35,1.11-0.72,1.11h-4.57v14.62c0,0.78,0.63,1.42,1.42,1.42h2.51 c0.78,0,1.42-0.63,1.42-1.42V54.75C63.41,54.62,63.38,54.49,63.35,54.37z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.63,50.78L38.75,32.45V6.25c0-3.18-2.58-5.75-5.75-5.75s-5.75,2.58-5.75,5.75v26.2L3.37,50.78 c-0.69,0.94-0.89,2.52-0.72,3.58c0.11,0.65,0.35,1.11,0.72,1.11h4.57h3.9h5.34h3.9h5.34h1.91h1.99h5.34h1.99h1.91h5.34h3.9h5.34 h3.9h4.57c0.37,0,0.61-0.46,0.72-1.11C63.52,53.3,63.32,51.72,62.63,50.78z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon3);
export default __webpack_public_path__ + "static/media/box_icon3.5a61cb8af17c1dfb3adfc3d22e3c45a7.svg";
export { ForwardRef as ReactComponent };